import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-right.svg';
import Button from 'components/Button/Button';
import { BUTTON_VARIANT } from 'constants/interfaces';
import { getLaunchpadIconSrc } from 'constants/launchpadIcons';

import RegulationHorizon from '../RegulationHorizon/RegulationHorizon';

import type IUnderstandIndicatorCardProps from './interfaces/IUnderstandIndicatorCardProps';

import styles from './sass/UnderstandIndicatorCard.module.scss';

function UnderstandIndicatorCard({ indicator, onOpen }: IUnderstandIndicatorCardProps) {
  const { t } = useTranslation();

  return (
    <article className={styles.root} data-indicator={indicator.id}>
      <div className={styles.head}>
        <div className={styles.heading}>
          <div className={styles.iconWrap}>
            <img
              src={getLaunchpadIconSrc(indicator.iconKey)}
              alt=""
              width={36}
              height={36}
            />
          </div>
          <h3 className={styles.title}>{t(indicator.titleI18nKey)}</h3>
        </div>
        {onOpen ? (
          <Button
            title={t('launchpad.open')}
            variant={BUTTON_VARIANT.openLink}
            endIcon={<ArrowRightIcon />}
            onClick={onOpen}
          />
        ) : null}
      </div>
      <dl className={styles.metrics}>
        {indicator.metrics.map((metric) => (
          <div key={metric.labelI18nKey} className={styles.metric}>
            <dt className={styles.metricLabel}>{t(metric.labelI18nKey)}</dt>
            <dd className={styles.metricValue}>{metric.value}</dd>
          </div>
        ))}
      </dl>
      {indicator.horizons?.length ? (
        <RegulationHorizon horizons={indicator.horizons} />
      ) : null}
    </article>
  );
}

export default UnderstandIndicatorCard;
